
import React, { useState,useEffect } from 'react';
import "./BackToTop.css";
import UpArrowImage from '../assets/Links/UpArrow.png';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show or hide the button based on scroll position
  const toggleVisibility = () => {
    if (window.scrollY > 0) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll to the top of the page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

    useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
     <>
      {isVisible && (
    <div className='back-to-top' onClick={scrollToTop}> 
          <img src={UpArrowImage} alt="Scroll up" />
    </div>
      )}
    </>
  );
};

export default BackToTop;